import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '@components/skeleton/skeleton.component';
import { Application } from '@enums/application.enums';

@Component({
  selector: 'app-table-skeleton',
  templateUrl: './table-skeleton.component.html',
  styleUrls: ['./table-skeleton.component.scss'],
  standalone: true,
  imports: [CommonModule, SkeletonComponent]
})
export class TableSkeletonComponent {
  @Input() rows: number = Application.THREE;
  @Input() columns: number = Application.ONE;
  @Input() showHeader = true;
  @Input() cellSkeletonClassName = 'h-60 w-full r-4 c-post';
  @Input() headerCellSkeletonClassName = 'h-60 w-full r-4 c-post';

  get rowIndices(): number[] {
    return Array.from({ length: Math.max(Application.ZERO, this.rows) }, (_, i) => i);
  }

  get colIndices(): number[] {
    return Array.from({ length: Math.max(Application.ZERO, this.columns) }, (_, i) => i);
  }
}
